/**
 * Safety Meeting API Service
 * Handles API requests related to safety meeting PDFs
 */

import { apiRequest } from "./axios";
import { API_PATHS } from "../../config";

/**
 * Fetches the safety meeting PDF for a given week
 *
 * @param {string} weekEnd - The week ending date in YYYY-MM-DD format
 * @param {string} language - Language code: "en"/"es" or "EN"/"ES" (default: "EN")
 * @returns {Promise<Blob>} PDF blob object
 */
export async function getSafetyMeetingPDF(weekEnd, language = "EN") {
  try {
    const response = await apiRequest(
      API_PATHS.SAFETYMEETING.GET_PDF,
      {
        week_ending: weekEnd,
        language: language,
      },
      {
        method: "POST",
        responseType: "blob", // Important: tells axios to expect binary data
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching safety meeting PDF:", error);
    throw error;
  }
}

/**
 * Fetches all safety meeting topics with crew data
 *
 * @returns {Promise<Array>} Array of meeting topic objects
 */
export async function getMeetingTopics() {
  try {
    const response = await apiRequest(
      API_PATHS.SAFETYMEETING.TOPICS,
      null,
      { method: "GET" }
    );
    return response;
  } catch (error) {
    console.error("Error fetching meeting topics:", error);
    throw error;
  }
}
